var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBancontact(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    className: "\\u2699   rs-3 as-q as-r as-s as-t as-c2 as-1k as-1l as-qg as-3s \\u269912oyhkg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EBF1F7",
    d: "M0 0h32v32H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bi_bancontact__a_:rc2:_0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.164 21.448c3.918 0 5.877-2.612 7.836-5.224H3v5.224h5.164Z",
    fill: "url(#bi_bancontact__b_:rc2:_1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.836 11c-3.918 0-5.877 2.612-7.836 5.224h13V11h-5.164Z",
    fill: "url(#bi_bancontact__c_:rc2:_2)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bi_bancontact__b_:rc2:_1",
    x1: 5.629,
    y1: 19.077,
    x2: 15.139,
    y2: 15.544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005AB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E3764"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bi_bancontact__c_:rc2:_2",
    x1: 16.787,
    y1: 16.677,
    x2: 26.885,
    y2: 13.232,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBA900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD800"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bi_bancontact__a_:rc2:_0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(3 11)",
    d: "M0 0h26v10.447H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBancontact);
export default __webpack_public_path__ + "static/media/BANCONTACT.d9b4c81f30ef7df848d12992d9772162.svg";
export { ForwardRef as ReactComponent };